export default __webpack_public_path__ + "static/media/logo-only.d758ed4f.png";